import {
  hideLoading,
  sessionExpired,
  setNotificationCount,
  showAlert,
  showLoading,
} from "../Actions/GeneralActions";

import Apis from "../../config/Apis";
import Axios from "../../config/Axios";
import { authHeaders, headers } from "../../utills";
import Storage from "../../utills/AsyncStorage";
import {
  get_logs,
  get_staff,
  getDealerDashboard,
  getUser,
  isLogin,
  IsReset,
  reset_staff,
} from "../Actions/AuthAction";

export const AuthMiddleware = {
  login: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("password", userdata?.password);
          formdata.append("type", userdata?.role.toLowerCase());
          formdata.append("device_id", userdata?.deviceID);
          formdata.append("timezone", userdata?.timezone);
          const data = await Axios.post(
            Apis.login,
            formdata,
            authHeaders.config(),
          );

          if (data?.status == 200) {
            const encodedData = JSON.parse(atob(data?.data?.data));
            console.log(encodedData);
            if (encodedData?.is_2fa_enabled == 1) {
              resolve(encodedData);
            } else {
              console.log("first");
              Storage.setToken(encodedData?.token);
              Storage.setUser("@user", JSON.stringify(encodedData));
              Storage.setERole("@role", JSON.stringify(encodedData?.type));
              Storage.setRole("role", JSON.stringify(encodedData?.type));
              Storage.setRedirect_URL(userdata?.redirect_url);
              dispatch(getUser(encodedData));
              dispatch(isLogin(true));
              dispatch(IsReset(encodedData?.password_reset_required || false));
            }
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  signUp: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("type", userdata.role);
          if (userdata.firstName) {
            formdata.append("first_name", userdata.firstName);
          }
          if (userdata.lastName) {
            formdata.append("last_name", userdata.lastName);
          }
          if (userdata.name) {
            formdata.append("name", userdata.name);
          }
          formdata.append("contact_no", userdata.contactNo);
          formdata.append("email", userdata.email);
          formdata.append("password", userdata.password);
          formdata.append("confirm_password", userdata.confirmPass);
          formdata.append("address", userdata.address);

          const data = await Axios.post(Apis.signUp, formdata);

          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "signup",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "signUp",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  verifyCodeOTP: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("type", params.type);
          formdata.append("id", params?.user_id);
          formdata.append("code", params?.code);
          const data = await Axios.post(
            Apis.verifyOtp,
            formdata,
            authHeaders.config(),
          );
          if (data?.status == 200) {
            const encodedData = JSON.parse(atob(data?.data?.data));
            resolve(encodedData);
            Storage.setToken(encodedData?.token);
            Storage.setUser("@user", JSON.stringify(encodedData));
            Storage.setERole("@role", JSON.stringify(encodedData?.type));
            Storage.setRole("role", JSON.stringify(encodedData?.type));
            dispatch(getUser(encodedData));
            dispatch(isLogin(true));
            dispatch(
              showAlert({
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  signUpVerifyCode: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("code", userdata?.code);
          formdata.append("type", userdata?.role);
          const data = await Axios.post(
            Apis.verifySignUpOtp,
            formdata,
            authHeaders.config(),
          );
          if (data?.status == 200) {
            const encodedData = JSON.parse(atob(data?.data?.data));
            resolve(encodedData);
            Storage.setToken(encodedData?.token);
            Storage.setUser("@user", JSON.stringify(encodedData));
            Storage.setERole("@role", JSON.stringify(encodedData?.type));
            Storage.setRole("role", JSON.stringify(encodedData?.type));
            dispatch(getUser(encodedData));
            dispatch(isLogin(true));
            dispatch(
              showAlert({
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  forgetPassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          // formdata.append("type", userdata?.role);
          const data = await Axios.post(Apis.sendVerificationOtp, formdata);
          if (data?.status == 200) {
            resolve(data?.data);
            dispatch(
              showAlert({
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
          // reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  forgotVerifyCode: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("code", userdata?.code);
          formdata.append("type", userdata?.role);
          const data = await Axios.post(
            Apis.verifyForgotPasswordCode,
            formdata,
          );
          if (data?.status == 200) {
            resolve(data?.data);
            dispatch(
              showAlert({
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
          // reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  changePassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", userdata?.email);
          formdata.append("type", userdata?.role);
          formdata.append("code", userdata?.code);
          formdata.append("password", userdata?.password);
          formdata.append("confirm_password", userdata?.confirmPass);
          const data = await Axios.post(Apis.resetPassword, formdata);
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Change password",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  resetPassword: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("old_password", userdata?.password);
          formdata.append("password", userdata?.newPassword);
          formdata.append("confirm_password", userdata?.confirmPass);
          formdata.append("logout", userdata?.logout);
          const data = await Axios.post(
            Apis.changePassword,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Change password",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updatePassword: (params) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("old_password", params?.password);
          formData.append("password", params?.newPassword);
          formData.append("confirm_password", params?.confirmPass);
          formData.append("logout", params?.logout);

          const { data } = await Axios.post(
            Apis.changePassword,
            formData,
            headers.config(),
          );
          if (data?.success) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Change password",
                message: data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  EmailNotification: (params) => {
    // console.log("pppppparamam", params);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("email_notifications", params?.email_notifications);
          formData.append("is_2fa_enabled", params.is_2fa_enabled);
          const { data } = await Axios.post(
            Apis.emailNotification,
            formData,
            headers.config(),
          );
          if (data?.success) {
            resolve(true);
            dispatch(getUser(data?.data));
            dispatch(
              showAlert({
                title: "Email Notifications",
                message: data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getUserData: () => {
    return (dispatch) => {
      // dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.getUserData, headers.config());
          if (data?.status == 200) {
            const encodedData = data?.data?.data;
            Storage.setUser("@user", encodedData);
            dispatch(getUser(encodedData));
            dispatch(
              setNotificationCount(
                data?.data?.data?.unread_notifications_count,
              ),
            );

            // const encodedData = JSON.parse(atob(data?.data?.data));
            // Storage.setUser("@user", JSON.stringify(encodedData));
            // dispatch(getUser(encodedData));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "login",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          // dispatch(hideLoading());
        }
      });
    };
  },
  updateProfile: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (userdata.first_name) {
            formdata.append("first_name", userdata.first_name);
          }
          if (userdata.last_name) {
            formdata.append("last_name", userdata.last_name);
          }
          if (userdata.name) {
            formdata.append("name", userdata.name);
          }
          formdata.append("email", userdata.email);
          formdata.append("address", userdata.address);
          formdata.append("contact_no", userdata.contact_no);
          // formdata.append("dealer_id", userdata.dealer_id);
          if (userdata.profile_picture)
            formdata.append("profile_picture", userdata.profile_picture);

          const data = await Axios.post(
            Apis.updateProfile,
            formdata,
            headers.config(),
          );
          if (data.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Profile Updated Sucessfully",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
            dispatch(getUser(data.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Profile",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  contactUs: (userData) => {
    console.log("Contact us data ", userData);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("message", userData?.message);
          const data = await Axios.post(
            Apis.contactUs,
            formdata,
            headers.config(),
          );
          if (data.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "contactUs",
                message: data?.data?.message,
                type: "Success",
                status: 200,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "contactUs",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  accountSetup: (payLoad) => {
    return (dispatch) => {
      dispatch(showLoading());

      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("business_name", payLoad?.business_name);
          formData.append("step", payLoad?.step);
          formData.append("business_email", payLoad?.business_email);
          formData.append("business_contact_no", payLoad?.business_contact_no);
          formData.append("business_address", payLoad?.business_address);
          // formData.append("dealer_id", payLoad?.dealer_id);
          formData.append("tax_identification", payLoad?.tax_identification);
          formData.append(
            "tax_identification_no",
            payLoad?.tax_identification_no,
          );
          formData.append("business_license_no", payLoad?.business_license_no);
          formData.append("logo", payLoad?.logo);
          formData.append("years_in_business", payLoad?.years_in_business);
          formData.append("description", payLoad?.description);

          const data = await Axios.post(
            Apis.accountSetup,
            formData,
            headers.config(),
          );
          if (data.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Account Setup",
                message: data?.data?.message,
                type: "Success",
                status: 200,
              }),
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Account Setup",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateCompanyProfile: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("name", userdata.name);
          formdata.append("email", userdata.email);
          formdata.append("contact_no", userdata.contactNo);
          formdata.append("address", userdata.address);
          formdata.append("tax_identification_no", userdata.identificationNo);
          formdata.append("business_license_no", userdata.licenseNo);
          formdata.append("years_in_business", userdata.businessYears);
          formdata.append("service_description", userdata.description);
          formdata.append("dealer_id", userdata.dealerId);
          if (userdata?.logo) formdata.append("logo", userdata.logo);

          const data = await Axios.post(
            Apis.updateCompanyProfile,
            formdata,
            headers.config(),
          );
          if (data.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Profile Updated Sucessfully",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
            dispatch(getUser(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "Profile",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  logout: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(Apis.logout, headers.config());
          if (data?.status == 200) {
            dispatch(
              showAlert({
                title: "logout",
                message: data.data.message,
                type: "Success",
              }),
            );
            resolve(data?.data?.data);
          }
        } catch (error) {
          // reject(true);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  ////////////////////////////////////////////////////////////Staff Module////////////////////////////////////////////////////////////
  createStaff: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_staff());
          const formdata = new FormData();
          formdata.append("first_name", userdata?.firstName);
          formdata.append("last_name", userdata?.lastName);
          formdata.append("email", userdata?.email);
          formdata.append("contact_no", userdata?.contactNo);
          formdata.append("role", userdata?.staffRole);
          for (const [i, element] of userdata?.permissionArr.entries()) {
            formdata.append(`permissions[${i}][name]`, element?.name);
            formdata.append(`permissions[${i}][is_access]`, element?.is_access);
          }
          const data = await Axios.post(
            Apis.createStaff,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_staff(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "create staff",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateStaff: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_staff());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          formdata.append("first_name", userdata?.firstName);
          formdata.append("last_name", userdata?.lastName);
          formdata.append("email", userdata?.email);
          formdata.append("contact_no", userdata?.contactNo);
          formdata.append("role", userdata?.staffRole);
          for (const [i, element] of userdata?.permissionArr.entries()) {
            formdata.append(`permissions[${i}][name]`, element?.name);
            formdata.append(`permissions[${i}][is_access]`, element?.is_access);
          }
          const data = await Axios.post(
            Apis.updateStaff,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_staff(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "create staff",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getStaff: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_staff());
          const data = await Axios.get(Apis.getStaff, headers.config());
          if (data?.status == 200) {
            resolve(data);
            dispatch(get_staff(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "get staff",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deleteStaff: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          dispatch(reset_staff());
          const formdata = new FormData();
          formdata.append("id", userdata?.id);
          const data = await Axios.post(
            Apis.deleteStaff,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            dispatch(get_staff(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "delete staff",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getDealershipDashboard: (userdata) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          const data = await Axios.post(
            Apis.dealershipDashboard,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(getDealerDashboard(data?.data?.data));
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "dashboard",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  delAcc: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const formdata = new FormData();
          formdata.append("password", userData?.password);
          const data = await Axios.post(
            Apis.delete_user,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data?.data);
            dispatch(
              showAlert({
                title: "delete account",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "delete account",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            }),
          );
          // reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  activityLogs: (staff_id, currentPage) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const formdata = new FormData();
          let query = "";
          if (staff_id) query += `?staff_id=${staff_id}&page=${currentPage}`;
          const data = await Axios.post(
            `${Apis.activityLogs}${query}`,
            formdata,
            headers.config(),
          );
          if (data?.status == 200) {
            resolve(data);
            dispatch(get_logs(data?.data?.data));
          }
        } catch (error) {
          dispatch(
            showAlert({
              title: "logs",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : error.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  // GeneralType: () => {
  //   return (dispatch) => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const data = await Axios.get(Apis.getAllTypes);
  //         if (data?.status == 200) {
  //           resolve(data?.data?.data);
  //           dispatch(getTypes(data?.data?.data));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "GeneralType",
  //             message: error?.response?.data?.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       }
  //     });
  //   };
  // },

  // Sociallogin: (userdata) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("email", userdata?.email);
  //         formdata.append("first_name", userdata?.given_name);
  //         formdata.append("last_name", userdata?.family_name);
  //         // formdata.append("device_id", userdata?.deviceID);
  //         formdata.append("role", userdata?.role);
  //         const data = await Axios.post(Apis.social_login, formdata);
  //         if (data?.status == 200) {
  //           const encodedData = data?.data?.data;
  //           Storage.setToken(encodedData?.token);
  //           Storage.setUser("@user", JSON.stringify(encodedData));
  //           Storage.setERole("@role", JSON.stringify(encodedData?.role));
  //           Storage.setRole("role", JSON.stringify(encodedData?.role));
  //           dispatch(getUser(encodedData));
  //           dispatch(isLogin(true));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "Sociallogin",
  //             message: error?.response?.data?.message
  //               ? error?.response?.data?.message
  //               : "Internal error",
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },
  // getUserData: () => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const data = await Axios.get(
  //           Apis.getUserData,
  //           headers.config()
  //         );
  //         if (data?.status == 200) {
  //           const encodedData = JSON.parse(atob(data?.data?.data));
  //           Storage.setUser("@user", JSON.stringify(encodedData));
  //           dispatch(getUser(encodedData));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "login",
  //             message: error?.response?.data?.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },
  // onChangeNotification: () => {
  //   return (dispatch) => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         dispatch(showLoading());
  //         const data = await Axios.get(
  //           Apis.updateNotificationSetting,
  //           headers.config()
  //         );
  //         if (data?.status == 200) {
  //           Storage.setUser("@user", JSON.stringify(data?.data?.data));
  //           dispatch(getUser(data?.data?.data));
  //           resolve(true);
  //         }
  //       } catch (error) {
  //         reject(error);
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // logout: () => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const data = await Axios.get(Apis.logout, headers.config());
  //         if (data) {
  //           resolve(true);
  //         }
  //       } catch (error) {
  //         if (error.message == "Request failed with status code 401") {
  //           resolve(true);
  //         } else {
  //           reject(error);
  //         }
  //       } finally {
  //         dispatch(hideLoading());
  //         resolve(true);
  //         Storage.clearStorage();
  //         dispatch(isLogout());
  //       }
  //     });
  //   };
  // },

  // updatePassword: (userdata) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("old_password", userdata?.currentPassword);
  //         formdata.append("new_password", userdata?.newPassword);
  //         formdata.append("confirm_password", userdata?.confirmPassword);
  //         const data = await Axios.post(
  //           Apis.updatePassword,
  //           formdata,
  //           headers.config()
  //         );
  //         if (data?.status == 200) {
  //           resolve(true);
  //           dispatch(
  //             showAlert({
  //               title: "Update password",
  //               message: data?.data?.message,
  //               type: "Success",
  //               status: data?.status,
  //             })
  //           );
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "Update password",
  //             message: error?.response?.data?.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // contactUs: (userdata) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("email", userdata?.email);
  //         formdata.append("query_title", userdata?.query_title);
  //         formdata.append("message", userdata?.message);
  //         const data = await Axios.post(
  //           Apis.contactUs,
  //           formdata,
  //           headers.config()
  //         );

  //         if (data?.status == 200) {
  //           resolve(true);
  //           dispatch(
  //             showAlert({
  //               title: "contactUs",
  //               message: data?.data?.message,
  //               type: "Success",
  //               status: 200,
  //             })
  //           );
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "contactUs",
  //             message: error?.response?.data?.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },
  // UpdateRole: ({ user_id, role }) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("user_id", user_id);
  //         formdata.append("role", role);

  //         const data = await Axios.post(
  //           Apis.updateRole,
  //           formdata,
  //           headers.config()
  //         );
  //         if (data?.status == 200) {
  //           resolve(data?.data);
  //           dispatch(
  //             showAlert({
  //               title: "UpdateRole",
  //               message: data?.data?.message,
  //               type: "Success",
  //               status: 200,
  //             })
  //           );
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: "UpdateRole",
  //             message: error?.response?.data?.message,
  //             type: "Error",
  //             status: error?.response?.status,
  //           })
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },
  // /Muneeeb code:
  // Login: (userData) => {
  //   return (dispatch) => {
  //     // dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         // let formdata = new FormData();
  //         // formdata.append("email", userData?.email);
  //         // formdata.append("password", userData?.password);
  //         // // formdata.append('device_id', userData?.DeviceToken);
  //         // formdata.append("role", userData?.role);
  //         // const { data } = await Axios.post(Apis.login, formdata);
  //         // if (data?.success) {
  //         localStorage.setItem("token", "data?.data?.token");
  //         localStorage.setItem("@user", "JSON.stringify(data?.data)");
  //         localStorage.setItem("role", userData);
  //         dispatch(getUser({ name: "michel" }));
  //         dispatch(isLogin(true));
  //         // dispatch(
  //         //   isLogin({ isLogin: true, userData: { name: "michel" } })
  //         // );
  //         //   dispatch(hideLoading());
  //         // } else {
  //         //   dispatch(hideLoading());
  //         //   dispatch(
  //         //     showAlert({ type: "error", message: data?.message })
  //         //   );
  //         // }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(showAlert({ type: "Error", message: "Network error" }));
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // logout: () => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         localStorage.clear();
  //         dispatch(getUser(null));
  //         dispatch(isLogin(false));
  //         dispatch(sessionExpired(false));
  //         resolve(true);

  //         // dispatch(isLogin(null))
  //       } catch (error) {
  //         reject(error);
  //         dispatch(showAlert({ type: "Error", message: "Network error" }));
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // getUserInfo: () => {
  //   return (dispatch) => {
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const { data } = await Axios.get(Apis.getUserInfo, {
  //           headers: headers.config(),
  //         });
  //         if (data?.success) {
  //           localStorage.setItem("@user", JSON.stringify(data?.data));
  //           dispatch(getUser(data?.data));
  //         } else {
  //           dispatch(showAlert({ type: "Error", message: data?.message }));
  //         }
  //       } catch (error) {
  //         reject(error);
  //       }
  //     });
  //   };
  // },

  // UpdateProfile: (userData) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();

  //         if (userData?.pickImage) {
  //           formdata.append("profile_image", userData?.pickImage);
  //         }
  //         formdata.append("first_name", userData?.Firstname);
  //         formdata.append("last_name", userData?.Lastname);
  //         formdata.append("contact_no", userData?.ContactNumber);
  //         for (const [i, document] of userData?.MultipleAddress.entries()) {
  //           if (document?.street) {
  //             formdata.append(`addresses[${i}][street]`, document?.street);
  //           } else {
  //             formdata.append(`addresses[${i}][street]`, null);
  //           }
  //           if (document?.state) {
  //             formdata.append(`addresses[${i}][state]`, document?.state);
  //           } else {
  //             formdata.append(`addresses[${i}][state]`, null);
  //           }
  //           if (document?.zipcode) {
  //             formdata.append(`addresses[${i}][zipcode]`, document?.zipcode);
  //           } else {
  //             formdata.append(`addresses[${i}][zipcode]`, null);
  //           }
  //           if (document?.id) {
  //             formdata.append(`addresses[${i}][address_id]`, document?.id);
  //           }
  //         }
  //         formdata.append("category_id", userData?.selectedCategory);
  //         // userData?.StartTime
  //         //   ? formdata.append("working_start_time", userData?.StartTime)
  //         //   : formdata.append("working_start_time", null);
  //         // userData?.EndTime
  //         //   ? formdata.append("working_end_time", userData?.EndTime)
  //         //   : formdata.append("working_end_time", null);
  //         // formdata.append('profile_image', null);

  //         const { data } = await Axios.post(Apis.updateProfile, formdata, {
  //           headers: headers.config(),
  //         });
  //         if (data?.success) {
  //           resolve(data);
  //           localStorage.setItem("@user", JSON.stringify(data?.data));
  //           dispatch(getUser(data?.data));
  //           dispatch(hideLoading());
  //         } else {
  //           dispatch(hideLoading());
  //           dispatch(showAlert({ type: "Success", message: data?.message }));
  //           // Alert.alert('Note', data?.message);
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(showAlert({ type: "Warning", message: "Network Error" }));
  //         // alert('Network Error');
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // ForgotPassword: (userData) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("email", userData?.email);
  //         const { data } = await Axios.post(Apis.forgotPassword, formdata);
  //         if (data?.success) {
  //           resolve(data);
  //           dispatch(hideLoading());
  //           dispatch(showAlert({ type: "Success", message: data?.message }));
  //         } else {
  //           dispatch(hideLoading());
  //           // Alert.alert('Note', data?.message);
  //           dispatch(showAlert({ type: "Warning", message: data?.message }));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(showAlert({ type: "Warning", message: "Network error" }));
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // ConfirmPassword: (userData) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("email", userData?.Email);
  //         formdata.append("password", userData?.Password);
  //         formdata.append("confirm_password", userData?.ConfirmPassword);

  //         const { data } = await Axios.post(Apis.change_password, formdata);
  //         if (data?.success) {
  //           resolve(data);
  //           dispatch(hideLoading());
  //         } else {
  //           dispatch(hideLoading());
  //           // Alert.alert('Note', data?.message);
  //           dispatch(showAlert({ type: "warning", message: data?.message }));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(showAlert({ type: "warning", message: "Network Error" }));
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // updatePassword: (userData) => {
  //   return (dispatch) => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formdata = new FormData();
  //         formdata.append("old_password", userData?.old_password);
  //         formdata.append("new_password", userData?.new_password);
  //         formdata.append("confirm_password", userData?.confirm_password);

  //         const { data } = await Axios.post(
  //           Apis.updatePassword,
  //           formdata,
  //           headers.config()
  //         );
  //         if (data?.success) {
  //           resolve(data);
  //           dispatch(hideLoading());
  //           dispatch(showAlert({ type: "Success", message: data?.message }));
  //         } else {
  //           dispatch(hideLoading());
  //           dispatch(showAlert({ type: "Warning", message: data?.message }));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             type: "Error",
  //             message: error?.response?.data?.message,
  //           })
  //         );
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  // /Muneeeb code:
};
